var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWtc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.317 19.954v-7.307c.037-.369.288-1.195.997-1.55.708-.354 1.328-.442 1.55-.442V7c-.185-.294-.753-.906-1.55-.995-.797-.088-3.875.996-5.314 1.55v13.063c.332.295 1.66.575 4.317-.664zm5.978.22v-9.077c-.367 0-1.417.228-2.648.495l-.784.17c-1.24.265-1.55.848-1.55 1.107v11.733c0 1.063.739 1.18 1.108 1.107 1.403-.295 4.384-.93 5.093-1.107.886-.222 1.328-.996 1.218-1.993-.08-.725-.278-.746-.678-.79a3.04 3.04 0 0 1-.54-.095c-.62-.177-1.07-1.107-1.217-1.55zm11.402 0v-9.077c-.366 0-1.417.228-2.648.495l-.784.17c-1.24.265-1.55.848-1.55 1.107v11.733c0 1.063.738 1.18 1.107 1.107 1.402-.295 4.384-.93 5.092-1.107.886-.222 1.328-.996 1.218-1.993-.08-.725-.279-.746-.68-.79a3.04 3.04 0 0 1-.538-.095c-.62-.177-1.07-1.107-1.218-1.55zm-5.977-7.527v7.307c-2.657 1.24-3.986.959-4.318.664V7.555c1.44-.554 4.517-1.638 5.314-1.55.797.089 1.365.701 1.55.996v3.655c-.222 0-.842.088-1.55.442-.709.355-.96 1.181-.996 1.55zM31 7.001v11.404c0 .295-.2.952-.996 1.217-.797.267-3.432.924-4.65 1.22-.332.11-1.062.021-1.328-1.219-.266-1.239-.11-7.6 0-10.626 0-.443.221-1.44 1.107-1.882.885-.443 3.616-.849 4.87-.996.333 0 .997.177.997.885z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWtc);
export default __webpack_public_path__ + "static/media/WTC.a3f148d2fe86e6bcee965f409a8dacb1.svg";
export { ForwardRef as ReactComponent };